export default "__VITE_ASSET__Ciw5kAAf__"